<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isCorporationsFetchPending"
                                class="-sm m-2 -base"/>
                        <template v-else>
                            Corporations
                        </template>
                    </span>
                    <LangSwitcher />
                </span>
                <span>
                    <button @click.prevent="handleCreateCorporation" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Create corporation
                    </button>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <h2 class="ml-3 text-1xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">Corporations</h2>
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="corporations"
                    :columns="columns"
                    :desc="desc"
                    @sortBy="handleSortBy"
                    @manageItem="handleManageCorporation"
                    @deleteItem="handleDeleteCorporation"
                    @editItem="handleEditCorporation"
                    editable
                    manageable
                    deletable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import Pagination from "../../components/partials/pagination"
import Search from "../../components/partials/search"

export default {
    data() {
        return {
            search: null,
            desc: false
        }
    },
    beforeMount() {
        this.$store.dispatch('corporations/getList', this.auth_user.role <= 2 ? {} : { search: {id: this.auth_user.corporation_id}})
    },
    computed: {
        isCorporationsFetchPending() {
            return this.$store.state.corporations.isCorporationsFetchPending
        },
        locale() {
            return this.$store.state.config.locale;
        },
        corporations() {
            return this.$store.state.corporations.list;
        },
        lastPage() {
            return this.$store.state.corporations.pagination.last_page
        },
        currentPage() {
            return this.$store.state.corporations.pagination.current_page
        },
        columns() {
            return {
                id: {},
                name: {}
            }
        },
        auth_user() {
            return this.$store.state.auth.auth_user
        }
    },
    methods: {
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('corporations/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': this.search ? {'email': this.search} : {}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleCreateCorporation() {
            this.$store.dispatch('corporations/resetSingle');
            this.$store.dispatch('modals/open', 'corporation-save');
        },
        handleEditCorporation(corporation) {
            this.$store.dispatch('corporations/setSingle', corporation);
            this.$store.dispatch('modals/open', 'corporation-save');
        },
        handleManageCorporation(corporation) {
            this.$router.push({name: 'corporation-show', params: {id: corporation.id}})
        },
        handleDeleteCorporation(corporation) {
            this.$store.state.corporations.single = corporation;
            this.$store.dispatch('modals/open', 'corporation-delete');
        }
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        Search,
        List,
        Pagination
    }
}
</script>
